import React from 'react';
import PropTypes from 'prop-types';

import './YoutubeEmbed.scss';

const YoutubeEmbed = ({ embedId, width, height }) => (
    <div id="yt-embed" className="video-responsive">
        <iframe
            width={width}
            height={height}
            src={`https://www.youtube.com/embed/${embedId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
        />
    </div>
);

YoutubeEmbed.propTypes = {
    embedId: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired
};

export default YoutubeEmbed;



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/YoutubeEmbed.js